import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionHeaderName,
} from "@transfr-inc/dashboard-components";
import { UnitLessonAccordion } from "./unit-lesson-accordion";
import "./course-unit-accordion.scss";
import clsx from "clsx";

export function CourseUnitAccordion({
  unit,
  isExpanded,
  expandedLessons,
  unitIndex,
  responsiveStyles,
  hideExpandProperties = false,
  courseId,
  courseName,
  credentialData,
  completionMap,
  classroomId,
  courseData,
  activityDependencies,
  preqEnabled,
  isTraineePage = false,
}) {
  const allCompleted = unit?.completed;
  const isLocked = courseData?.prerequisitesEnabled ? unit?.locked : false;

  return (
    <Accordion
      className="course-unit-accordion"
      isOpen={(isTraineePage || !isLocked) && isExpanded}
    >
      <div className="course-unit-accordion-header">
        <AccordionHeader>
          <AccordionHeaderName>
            <div className="course-unit-accordion-header-name">
              <div>
                <div className="unit-title-badge">
                  <div>
                    Unit {unitIndex}: {unit?.title}
                  </div>
                  <span className="badge">{unit?.lessons?.length || 0}</span>
                </div>
              </div>
              <div
                className={clsx("completed-cell", allCompleted && "completed")}
              >
                {allCompleted ? (
                  <FontAwesomeIcon icon="fa-solid fa-circle-check" />
                ) : isLocked ? (
                  <FontAwesomeIcon icon="fa-regular fa-lock" />
                ) : (
                  <FontAwesomeIcon icon="fa-regular fa-circle" />
                )}
              </div>
            </div>
          </AccordionHeaderName>
        </AccordionHeader>
      </div>
      <AccordionBody>
        <div className="lesson-accordion-container">
          {unit?.lessons?.map((lesson, index) => (
            <UnitLessonAccordion
              key={lesson.id}
              lesson={lesson}
              lessonIndex={index + 1}
              isExpanded={expandedLessons?.has(lesson.id)}
              responsiveStyles={responsiveStyles}
              courseId={courseId}
              courseName={courseName}
              unitName={unit.title}
              unitIndex={unitIndex}
              credentialData={credentialData}
              unitId={unit.id}
              completionMap={completionMap}
              classroomId={classroomId}
              courseData={courseData}
              activityDependencies={activityDependencies}
              preqEnabled={preqEnabled}
              isTraineePage={isTraineePage}
            />
          ))}
        </div>
      </AccordionBody>
    </Accordion>
  );
}
